import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

export const useTableStyles = makeStyles((theme: Theme) => ({
  addUserButtonIcon: {
    marginRight: theme.spacing(1)
  },
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(2)
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  toolbarRight: {
    display: 'flex',
  }
}))